export enum Stage {
  CUPON_INFO = "CUPON_INFO",
  USER_INFO = "USER_INFO",
  PAYMENT_FORM = "PAYMENT_FORM"
}

export interface ICheckoutPage {
  publicId: string;
  marketingVideoURL?: string;
  totalPrice?: string;
  course: {
      id: string;
      name: string;
      levels: ILevel[];
  };
  timers: ITimer[];
  codes: ICode[];
  buttonTitle?: string;
  buttonDescription?: string;
  updatedAt?: string;
}

export interface PriceDetail {
  totalPrice: number;
  totalDiscountPercentPerCode: number;
  totalDiscountPercentPerTimer: number;
}

export interface IpApiResponse {
  status: 'success' | 'fail';
  country: string;
  countryCode: string;
  region: string;
  regionName: string;
  city: string;
  zip: string;
  lat: number;
  lon: number;
  timezone: string;
  isp: string;
  org: string;
  as: string;
  query: string;
}
